const STORAGE_PREFIX =
  import.meta.env.VITE_PUBLIC_MEDPLUM_STORAGE_PREFIX || "medplum";
export const MEDPLUM_STORAGE_PREFIX = `${STORAGE_PREFIX}:`;
export const MEDPLUM_LOGINS_STORAGE_KEY = `${MEDPLUM_STORAGE_PREFIX}logins`;

export const MEDPLUM_APP_URL = import.meta.env.VITE_PUBLIC_MEDPLUM_APP_URL;
